import React, { Fragment, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/index";
import { NotificationApi } from "@apis/index";
import Table from "@components/table";
import Wrapper from "@components/wrapper";
import Row from "@components/row";
import DropDown from "@components/fields/dropdown";
import { Formik, Form } from "formik";

const NotificationHistoryList = () => {
  const {
    items: notifications,
    totalItems,
    totalPages,
    loading,
  } = useSelector((state: RootState) => state.allNotifications);

  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
    role: "",
    type: "",
    search: "",
  });

  const fetchNotifications = useCallback(async () => {
    try {
      await NotificationApi.list({
        state: "allNotifications",
        params: {
          page,
          limit: 20,
          role: filters.role || undefined,
          type: filters.type || undefined,
          search: filters.search || undefined,
        },
      });
    } catch (error) {
      console.error("Failed to fetch notification history:", error);
    }
  }, [page, filters]);

  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  const columns = [
    { title: "SN", key: "sn", render: (_, i) => <p>{(page - 1) * 20 + i + 1}</p> },
    { title: "Title", key: "title" },
    { title: "Body", key: "body" },
    { title: "Role", key: "userRole", render: (item: any) => <p>{item.userRole?.toUpperCase()}</p> },
    { title: "Type", key: "type", render: (item: any) => <p>{item.type?.toUpperCase()}</p> },
    {
      title: "Created At",
      key: "createdAt",
      render: (item: any) => <p>{new Date(item.createdAt).toLocaleString()}</p>,
    },
  ];

  return (
    <Fragment>
      <Wrapper>
        <Formik
          initialValues={filters}
          onSubmit={(values) => {
            setFilters(values);
            setPage(1);
          }}
        >
          {({ submitForm, setFieldValue }) => (
            <Form>
              <Row styleRow="margin-bottom: 20px; gap: 10px; align-items: center;">
                <DropDown
                  name="role"
                  label="Role"
                  options={[
                    { id: "", name: "All Roles" },
                    { id: "customer", name: "Customer" },
                    { id: "store", name: "Store" },
                    { id: "delivery", name: "Delivery" },
                  ]}
                  titleAsKey="name"
                  valueAsKey="id"
                  placeholder="Filter by Role"
                  onChange={(val) => {
                    setFieldValue("role", val);
                    submitForm();
                  }}
                  styleInput="width: 200px"
                />
                <DropDown
                  name="type"
                  label="Type"
                  options={[
                    { id: "", name: "All Types" },
                    { id: "order", name: "Order" },
                    { id: "wallet", name: "Withdraw/Wallet" },
                    { id: "system", name: "System" },
                    { id: "broadcast", name: "Broadcast" },
                  ]}
                  titleAsKey="name"
                  valueAsKey="id"
                  placeholder="Filter by Type"
                  onChange={(val) => {
                    setFieldValue("type", val);
                    submitForm();
                  }}
                  styleInput="width: 200px"
                />
              </Row>
            </Form>
          )}
        </Formik>

        <Table
          loading={loading}
          searchKeys={["title", "body"]}
          text="Notification History"
          columns={columns}
          data={notifications}
          pageControlled={page}
          totalItems={totalItems}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      </Wrapper>
    </Fragment>
  );
};

export default NotificationHistoryList;
